/*
  --- Overview ---
  This file is root of any content creation (Study materials, Question papers and Test papers ).
   For all the settings and data are in component state for Testpaper and Studay material.
  But only for question paper we are using redux store. 
  Initially, question creation is also part of the state but we have added redux for Question
  papers creation letter to improve performance, create code more readable, and to avoid bugs.
  --- Validations ---
  -- Test paper and study material validation 
  All the validation runs inside section in content for test paper and study material It is old
  written code any onchange event emit a event and update the reducer for redux and run update based on some setInterval
  I am also not able to understand it properly and also lot of condtions out there which are also vary hard to understand.
  -- Question paper validation 
  In case of question papers validation it uses a utils function and redux data state.
*/

import React, { Component } from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { WithStyles, createStyles, Grid, Button, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

//related component
import PreviewPageInfo from '../components/PreviewPageInfo';
import ContentDeleteConfirm from '../components/ContentDeleteConfirm';
import OtherRelatedContent from '../components/OtherRelatedContent';
import SharedContentWith from '../components/SharedContentWith';
import HeaderTool from '../components/ContentCreate/HeaderTool';
import BreadcrumbCreateContent from '../components/ContentCreate/BreadcrumbCreateContent';
import SectionsInContent from '../components/SectionsInContent';
import VideoSectionInContent from '../components/VideoSectionInContent';
import AudioSectionInContent from '../components/AudioSectionInContent';
import { showMsg as showAlert } from '../../course/actions/loaderAlert';

//create components
import TestPaperCreate from '../components/ContentCreate/TestPaperCreate';
import ParagraphCreate from '../components/ContentCreate/ParagraphCreate';
import MatrixCreate from '../components/ContentCreate/MatrixCreate';
import MultipleChoiceCreate from '../components/ContentCreate/MultipleChoiceCreate';
import StudyCreate from '../components/ContentCreate/HStudyNotesCreate';
import AddDetailsVideo from '../components/ContentCreate/AddDetailsVideo';
import StudyNotesCreate from '../components/ContentCreate/StudyNotesCreate';
import SampleProblem from '../components/ContentCreate/SampleProblem';
import FormulaCreate from '../components/ContentCreate/FormulaCreate';


//services
import contentService from '../services/contentService';


//types and data
import ContentData, { StepWiseSolution } from '../types/ContentData';
import ContentSubtypeData from '../types/ContentSubtypeData';
import ContentFormData from '../types/ContentFormData';
import getDefaultFormData, { contentForPassageTypeQuestion } from '../types/ContentFromDataDefault';
import ContentDataDefault from '../types/ContentDataDefault';
import ContentFormDataError from '../types/ContentFormDataError';
import ContentFormDataErrorDefault from '../types/ContentFormDataErrorDefault';

//actions
import { eventFired } from '../actions/contentInSectionAction';
import { tabClicked } from '../actions/wrapperTabActions';
import { any } from 'prop-types';
import { setContentId, getContentId, validateSyllabus, validateTags, validateAnswer, calCulateProgressBar, getPropertyValue, getUserType, checkForTeacherUser } from '../../../utils';
import LoaderComponent from '../../common/LoaderComponent';
import { MyPATGlobalLoader, MyPATToaster } from '../../common';
import EasyMaths from '../components/EasyMaths';
import { questionActions } from '../reducers/questionCreateReducer';
import SectionsInContentQuestion from '../components/SectionsInContentQuestion';
import SectionsInContentStudyMaterial from '../components/SectionInContentStudyMaterial';
import { contentTypesForContentHistoryMap, QUESTION_TYPES, CONTENT_STATES,AudioUrlImage, QUESTION_TYPE, QUESTION_TYPE_CODE, CONTENT_SPECIAL_PURPOSES, AUTHORING_CONTENT_TYPES, CONTENT_SECTION_KEYS, MODULE_TO_TEST_PERMISSION_MAP, MODULE_TO_QUESTION_PERMISSION_MAP, USER_TYPE, titleCase, CONTENT_TYPE, CONTENT_SECTION_TYPES } from '../../../constants/comman';
import { studyActions } from '../reducers/notesStateReducers';
import { getTimeInSecs, getTimeUnit, getTime } from '../../../utils/getOffset.utils';
import { videoDetailsActions } from '../reducers/videoDetailsReducers';
import { audioDetailsActions } from '../reducers/audioDetailsReducer';

//Dummy data
import videoUploadService from '../services/videoUploadService';

import contentActions from '../actions/contentActions';
import { contentRequestStateAction } from '../../content-request/reducers/contentRequestStates';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import { contentRequestAccordianActions } from '../../content-request/reducers/contentRequestAccordianState';
import FeedbackPreview from '../../content-request/components/FeedbackPreview';
import {
  getFeedback
} from '../../content-request/actions/contentRequestActions'
import MyPATCollapseSection from '../../common/MyPATCollapseSection';
import MyPATCollapseSectionItem from '../../common/MyPATCollapseSectionItem';
import { getEditRights, notePayload, setAddConceptAndChapter,pagesInArrayForm,getAttachmentServerURl } from '../helper/notesPayload';
import ContentSuggestions from '../components/ContentSuggestions';
import { AllQuestionBenchmarks } from '../types/Benchmarks';
import CheckDuplicate from "../components/CheckDuplicate";
import {CloseOutlined as CloseIcon } from '@material-ui/icons';
import InfoIcon from '@material-ui/icons/Info';
import { GenericPreviousExamItem, PreviousExamItem } from '../types/PreviousYearsQuestion';
import { getGenericPrevExams } from '../helper/questionTab';
import { Attachment } from "../../common/MyPATUploader";
import * as JSLZString from 'lz-string';
import { makeDeepCopy } from '../../course-Management/helpers/helpers';
import { FEEDBACK_VALIDATOR_ACTIONS, NEW_FEEDBACK_TIME_TO_SHOW } from '../helper/contentValidation';
import ContentValidationEditHistory from '../components/ContentCreate/ContentValidationEditHistory';
import FeedbackSidebar from '../components/ContentCreate/FeedbackSidebar';
import { PROPS_REMEDIAL_KEY, REMEDIAL_PAGE_KEY } from '../components/ContentCreate/RemedialComponent/RemedialQuestionConstants';

////START -> onscroll "Sections in This Content" will be fixed, inner html will be scrolled if anymore steps section added.



////END --> onscroll "Sections in This Content" will be fixed, inner html will be scrolled if anymore steps section added.

const styles = (theme: Theme) => createStyles({
  root: {
    "math-editor-workplace-container": {
      "width": "100%",
      "height": "90px"
    },
  },
  sidePanel: {
    paddingRight: '30px !important',
    '& > *': {
      marginBottom: theme.spacing.unit + 2,
      // boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
      borderRadius: 4,
      transition: 'all .4s ease-in-out',
    },

    '&': {
      width: '100%',
      position: 'sticky',
      // zIndex: 1,
      top: '108px',
      right: '0',
      overflowX: 'hidden',
      height: '100%',
    }
  },
  sidePanel2: {
    '& > *': {
      marginBottom: theme.spacing.unit + 2,
      background: '#FFFFFF',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
      borderRadius: 4
    },

    '&': {
      width: '100%',
      position: 'fixed',
      zIndex: 1,
      top: '70px',
      right: '0',
      overflowX: 'hidden',
      height: '100%',
    }
  },
  wrapper: {
    padding: theme.spacing.unit,
    marginBottom: '110px',
    marginTop: '15px',
  },
  "fixedBox": {
    position: 'sticky',
    top: '108px',
    zIndex: 10,
  },

  "fixedBoxfixed": {
    position: 'fixed',
    right: '20px',
    bottom: '0',
    width: '24%',
  },
  marginTop20:{
    marginTop: '20px',
  },
});

// @ts-ignore
const ContentSaveContext = React.createContext({
  autoSave: () => {},
});
interface ContentCreateProps extends WithStyles<typeof styles> {
  match: any,
  history: any,
  progressInSection: Function,
  contentList: ContentData[],
  validations: any,
  tagsList: any,
  contentSubtype: {
    list: ContentSubtypeData[],
    question: ContentSubtypeData[],
    testpapers: ContentSubtypeData[],
  },
  eventFired: Function,
  location: any,
  notesData: any,
  QuestionList: [],
  setTitle: Function,
  setOptionsContent: Function,
  setMatrixOptionsContent: Function,
  setCorrectAnswer: Function,
  setCustomAnswer: Function,
  setSolutionContent: Function,
  setQuestionHints: Function,
  setSubjects: Function,
  setDifficultyLevel: Function,
  setDifficultyType: Function,
  setTags: Function,
  setEditRights: Function,
  setValidations: Function,
  setDraftId: Function,
  setDefaultCorrectAnswer: Function,
  setSecondarySubjects: any;
  setIsValidAttempts: Function,
  setIdealTime: Function,
  setNotesData: Function,
  tabClicked: Function,
  setVideoDetailsData: Function,
  setAudioDetailsData: Function,
  videoContentData: any,
  audioContentData: any,
  uploadedVideoUrl: string,
  showAlert: any;
  setRequiresForceSaveForChallenge: (val: boolean) => void;
  setRelevantExams: Function;
  setSyllabusExams: Function;
  setStepWiseSolutions: (data: StepWiseSolution[][]) => void;
  setPublishedContent: Function,
  accordianCreateTouched: any,
  setIsComingFrom: Function,
  setAccordingTouchIndex: Function,
  setAccordianTouchWhileCreate: Function,
  accordianTest: any,
  setTestAccordian: Function,
  fromFeedback: boolean,
  prevPath?: string,
  contentRequestId: string,
  sliderData?: any;
  onContentChange?: Function,
  closeReviewContainer?: Function,
  currentQuestionNumber?: number,
  currentTestNumber: number,
  getFeedback: Function,
  feedBackData: any,
  authorType: string;
  refreshFeedback: boolean;
  handleEditFromFeedback: Function,
  fromURL?: string,
  handlePreviewFromFeedback: Function,
  // NEW ONES
  title: string,
	optionsContent: any,
	type: string,
	subType: any,
	subjects: any,
	requestId: string,
	secondarySubjects: any,
	difficultyLevel: any,
	difficultyType: any,
	tags: any,
	defaultCorrectAnswersForParagraph: any[],
	correctAnswer: any,
  customAnswer: boolean,
  syllabusExams: any,
	alternateAnswer: boolean,
	isValidAttempts: boolean,
	defaultCorrectAnswer: any,
	solutionContent: string,
	stepWiseSolution: StepWiseSolution[],
	questionHints: string,
	showMsg: any,
	content: any,
	formData: ContentFormData,
	refreshContent: Function,
	getCommentCount: (contentId: string) => void,
	commentCount: number,
	editorId: any,
	lockData: any,
	fetchEditLockInfo: Function,
	handleFormSubmit: () => {},
	matrixOptionContent: any,
	idealTime: any,
	allQuestionBenchmarks: AllQuestionBenchmarks,
	updateQuestionBenchmarks: any;
	templateChanged: Function,
	requiresForceSaveForChallenge: boolean;
	relevantExams: any;
	handleArrowClick: Function,
	addFeedbackActive: Function,
	previewClicked: Function,
	setFeedbackClose: Function,
  suggestions:{similarContents:any [],duplicateContents:any []},
  setContentSuggestions:(params:{type:string,id:string})=>void,
  currentlyFocusedSection:string,
  questionPreviousExams: { [key :string ]:PreviousExamItem []};
  setPreviousExams:Function;
  handleNotesData: any,
  showLoader: any;
  hideLoader: any;
  resetNotesData: Function;
  setalternateAnswer: Function;
  setSelectedGoals: Function;
  setSpecialPurposes: Function;
  questionSpecialPurposes: any;
  setAllRelevantExams: Function;
  setAllPreviousExams: Function;
  setFtreRelevantExam: Function;
  remedialQuestionIds: any;
}

interface ContentCreateStates {
  loadingFormData: boolean,
  formData: any,
  originalFormData: any,
  formDataError: ContentFormDataError,
  sectionInContentStatus: any,
  content: any,
  pageState: any,
  isDeleteDialogOpen: boolean,
  editorId: any,
  questionData: any,
  backFromQuestion: any,
  questionSectionIndex: any,
  questionSubSectionIndex: any,
  questionList: [],
  selectedQuestionsList: any[],
  publishedStateQuestion: any[],
  passageId: string,
  contentForParagraph: any[],
  contentHistory: any,
  defaultCorrectAnswersForParagraph: any[],
  isTestAttampted: boolean,
  testAttemptData: any,
  hasMyLibraryQueue: boolean,
  contentRequestIds: any,
  openFeedback: boolean,
  clickedfeedbackData: any;
  sectionCurrentlyEditing: string;
  showToastMsg:boolean;
  activeTab: string;
  notesPdfAttachment:Attachment[];
  updateTabState:Function;
  validationFeedbacks: any;
  validationEditHistory: any;
  activeValidationFeedbackSection: string;
  activeValidationFeedbackIndex: number;
  activeValidationFeedbackData: any;
  canSubmitToAnotherValidator: boolean;
  validationStatus: string;
  pendingValidationComments: boolean;
  selectedQuestionRef: any;
  draftContentFormData: any;
  feedbackReplyId: string;
  alreadyAddedQuestions: any;
}

const initialQuestionState = {
  searchId: '',
  title: '',
  content_Id: '',
  addInstruction: '',
  attempt: true,
  subHeading: ''
};
const initialTheoryState = {
  theoryDescription: '',
  isPageFull: false,
  subHeading: ''
};
const initialVideoState = {
  videoURL: '',
  videoDescription: '',
  subHeading: ''
}
const initialAudioState = {
  videoURL: '',
  videoDescription: '',
  subHeading: ''
}

class ContentCreate extends Component<ContentCreateProps, ContentCreateStates> {
  formChangeCount: any = 0;
  debouncedSave: Function

  constructor(props: ContentCreateProps) {
    super(props);
    let defaultFromData = null;
    if (_.get(this.props, "match.params.type", "") === 'question') {
      defaultFromData = getDefaultFormData(_.get(this.props, "match.params.subType"))
    } else {
      defaultFromData = getDefaultFormData()
    }
    this.state = {
      loadingFormData: true,
      formData: defaultFromData,
      originalFormData: defaultFromData,
      sectionCurrentlyEditing: '', // used for validation
      pageState: {},
      formDataError: ContentFormDataErrorDefault,
      sectionInContentStatus: {},
      content: ContentDataDefault,
      isDeleteDialogOpen: false,
      editorId: "",
      backFromQuestion: false,
      questionData: [],
      questionSectionIndex: null,
      questionSubSectionIndex: null,
      questionList: [],
      selectedQuestionsList: [],
      publishedStateQuestion: [],
      passageId: '',
      contentForParagraph: [],
      contentHistory: [],
      defaultCorrectAnswersForParagraph: [],
      isTestAttampted: false,
      testAttemptData: null,
      hasMyLibraryQueue: false,
      contentRequestIds: {
        requestIds: []
      },
      openFeedback: false,
      clickedfeedbackData: {},
      showToastMsg:false,
      activeTab: "Type Notes",
      notesPdfAttachment:[],
      updateTabState:()=>{},
      validationFeedbacks: [],
      validationEditHistory: [],
      activeValidationFeedbackSection: '',
      activeValidationFeedbackIndex: -1,
      activeValidationFeedbackData: {},
      canSubmitToAnotherValidator: false,
      validationStatus: '',
      pendingValidationComments: false,
      // @ts-ignore
      selectedQuestionRef: React.createRef(),
      draftContentFormData: {},
      feedbackReplyId: '',
      alreadyAddedQuestions: {},
    };

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.getCreateComponent = this.getCreateComponent.bind(this);
    this.save = this.save.bind(this);
    this.updateCompletionPercent = this.updateCompletionPercent.bind(this);
    this.deleteContent = this.deleteContent.bind(this);
    this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
    this.getContentDetails = this.getContentDetails.bind(this);
    this.refreshContent = this.refreshContent.bind(this);
    this.changeFormDataError = this.changeFormDataError.bind(this);
    this.updateFormData = this.updateFormData.bind(this);
    this.moveToPlanned = this.moveToPlanned.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.addFeedbackActive = this.addFeedbackActive.bind(this);
    this.handleFeedbackClick = this.handleFeedbackClick.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
    this.emptyClickedData = this.emptyClickedData.bind(this);
    this.submitForVerify = this.submitForVerify.bind(this);
    this.loadMoreFeedback = this.loadMoreFeedback.bind(this);
    this.switchToPreview = this.switchToPreview.bind(this);
    this.debouncedSave = _.debounce(this.save, 3000);
    this.autoSaveContent=this.autoSaveContent.bind(this);
    this.setNotesPdfFile=this.setNotesPdfFile.bind(this);
  }

  getQuestionList = (list: any) => {
    this.setState({ questionList: list });
  };

  updateActiveStatusTab=(updateTabState:Function)=>{
    this.setState({updateTabState})
  }

  componentDidMount() {
    this.props.resetNotesData();
    this.props.setPublishedContent(null)
    this.getContentDetails();
    this.getValidationDetails();
  }

  getValidationDetails() {
    const id = _.get(this.props, "match.params.contentId", "");
    const isTeacher = checkForTeacherUser(this.state.content);
    if (!isTeacher) {
      return;
    }
    contentRequestServices.getValidationData({contentId: id.substring(0, 24)}).then((res: any) => {
      const { feedbacks = [], editHistory = [], canSubmitToAnotherValidator = false, status = '' } = res || {};
      if (status && ![FEEDBACK_VALIDATOR_ACTIONS.REJECTED, FEEDBACK_VALIDATOR_ACTIONS.PUBLISHED].includes(status)) {
        this.props.history.push("/");
      }
      this.setState({
        validationFeedbacks: feedbacks,
        validationEditHistory: editHistory,
        canSubmitToAnotherValidator,
        validationStatus: status,
      });
      this.checkPendingValidationComments();
    })
  }

  checkPendingValidationComments() {
    const { validationFeedbacks = [] } = this.state;
    let pendingValidationComments = false;
    for(let i=0;i<validationFeedbacks.length;i++){
      const { actions = [] } = validationFeedbacks[i];
      if (actions.length && !actions[actions.length-1].authorAction) {
        pendingValidationComments = true;
        break;
      }
    }
    this.setState({
      pendingValidationComments,
    });
  }

  closeFeedback(status: string){
    this.setState({
      openFeedback: false
    })
    if(status === 'resolve') {
      this.setState({
        clickedfeedbackData: {}
      })
    }
  }

  componentDidUpdate(prevProps: any) {
    let {
      formData,
      backFromQuestion,
      questionData,
      questionSectionIndex: sIndex = 0,
      questionSubSectionIndex: ssIndex = 0
    } = this.state;
    const type = _.get(this.props, "match.params.type", "") 
    if (backFromQuestion && !_.isEmpty(questionData)) {
      // this.refreshContent();
      let questionExist = false;
      if (
        formData["data"] != undefined &&
        formData.data["sections"] != undefined &&
        formData.data.sections.length > 0
      ) {
        if (
          formData.data.sections[sIndex].subSection[ssIndex].questions ==
          undefined
        ) {
          formData.data.sections[sIndex].subSection[ssIndex]["questions"] = [];
        }

        if (
          formData.data.sections[sIndex].subSection[ssIndex].questions.length >
          0
        ) {
          let questions =
            formData.data.sections[sIndex].subSection[ssIndex].questions;
          if (questions.length) {
            questionExist = _.some(
              questions,
              question => question.content_Id.content_Id == questionData._id
            );
          }
        }

        if (!questionExist) {
          if (
            formData.data.sections[sIndex].subSection[ssIndex].questions &&
            formData.data.sections[sIndex].subSection[ssIndex].questions !=
            undefined
          ) {
            let qId = {
              content: questionData.content || null,
              contentId: questionData.contentId || null,
              _id: questionData._id
            };
            let content_Id = {
              aclMetaData: questionData.aclMetaData,
              authors: questionData.authors,
              completionPercent: questionData.completionPercent,
              contentId: questionData.contentId,
              contentReviewer: questionData.contentReviewer,
              contentSubTypeCode: "0",
              contentTypeCode: "question",
              content_Id: questionData._id,
              createdAt: questionData.createdAt,
              status: questionData.status,
              difficultyLevel: questionData.difficultyLevel,
              difficultyType: questionData.difficultyType,
              relevantExams: questionData.relevantExams,
              favourites: questionData.favourites,
              subjects: questionData.subjects,
              tags: questionData.tags,
              title: questionData.content[0].questionContent,
              updatedAt: questionData.updatedAt,
              _id: `${questionData._id}question`
            };
            let questionSerialNo =
              formData.data.sections[sIndex].subSection[ssIndex].questions
                .length;
            if (questionData.passageData && questionData.passageData.length > 0) {
              questionData.passageData.forEach((item: any) => {
                item._id = item.id + 'question'
                delete item['id']
                content_Id = { ...content_Id, ...item }
                let tempData = {
                  content_Id,
                  qId,
                  questionSerialNo
                };
                questionSerialNo++;
                formData.data.sections[sIndex].subSection[ssIndex].questions.push(
                  tempData
                );
              })
            } else {
              let tempData = {
                content_Id,
                qId,
                questionSerialNo
              };

              formData.data.sections[sIndex].subSection[ssIndex].questions.push(
                tempData
              );
            }
            // correct question sequence 
            let qSerialNo = 0
            formData.data.sections.map((section: any) => {
              section.subSection.map((subSec: any) => {
                subSec.questions && subSec.questions.map((quest: any, i: number) => {
                  qSerialNo = qSerialNo + 1
                  quest.questionSerialNo = qSerialNo
                })
              })
            }) 

            this.setState({ formData: { ...this.state.formData, ...formData },
               backFromQuestion: false });
          }
        }
      }
    }
    if (prevProps.refreshFeedback !== this.props.refreshFeedback) {
      if(this.props.fromFeedback) {
      if(this.state.content.content.questionType !== "Paragraph") {
        this.props.getFeedback(this.props.contentRequestId, this.state.content.content._id, 1);
      } else if(this.state.content.content.questionType === "Paragraph"){
        let resultIds = this.state.content.content.content.map((data: any) => data.paragraphQuestionId);
        resultIds = resultIds.join(',');
        if(this.props.fromFeedback){
          this.props.getFeedback(this.props.contentRequestId, resultIds, 1);
        }
      }else {
        this.props.getFeedback(this.props.contentRequestId, this.state.content.content._id, 1);
      }
    }
  }
  if (prevProps.match !== this.props.match) {
    if(this.props.fromURL === "edit") {
   this.getContentDetails();
    }
  }
  const duplicateContents = _.get(this.props.suggestions, 'duplicateContents', []);
  const similarContents = _.get(this.props.suggestions, 'similarContents', []);

  if(prevProps.suggestions!==this.props.suggestions && (duplicateContents.length !== 0 || similarContents.length !== 0)){ 
         this.setState({showToastMsg:true});
      }  
  }

  setHasMylibraryQueue = () => {
    this.setState({ hasMyLibraryQueue: true })
  }

  handleNotesData = (updateNotesData: any) => {
    this.props.setNotesData(updateNotesData);
    
    this.setState({
      content: {
        ...this.state.content,
        ['completionPercent']: this.props.notesData.completionPercent,
      }
    });

  }

  handleVideoDetailsData = (updateVideoDetailsData: any) => {
    const updatedState = { ...this.props.videoContentData, ...updateVideoDetailsData };
    this.setState(prevState => {
      const updatedFormState = { ...JSON.parse(JSON.stringify(prevState.formData)), ...JSON.parse(JSON.stringify(updateVideoDetailsData))};
      return {
        ...prevState,
        formData: JSON.parse(JSON.stringify(updatedFormState))
      }
    })

    this.props.setVideoDetailsData({ ...updatedState });
  }
  handleAudioDetailsData = (updateAudioDetailsData: any) => {
    const updatedState = { ...this.props.audioContentData, ...updateAudioDetailsData };
    this.setState(prevState => {
      const updatedFormState = { ...JSON.parse(JSON.stringify(prevState.formData)), ...JSON.parse(JSON.stringify(updateAudioDetailsData))};
      return {
        ...prevState,
        formData: JSON.parse(JSON.stringify(updatedFormState))
      }
    })

    this.props.setAudioDetailsData({ ...updatedState });
  }

  componentCleanup = () => {
    return this.save(true);
  }

  refreshContent() {
    this.getContentDetails();
  }

  setUpdatedPagesNotesData = () => {
    const { pageState = {} } = this.state;
    const { setNotesData } = this.props;
    // this.setState({
    //   notesData: { ...notesData, pageState: { ...pageState } },
    // });
    setNotesData({ pageState: { ...pageState } })
  }

  getContentDetails() {
    let contentId = _.get(this.props, "match.params.contentId", "");
    let subType = _.get(this.props, "match.params.subType", "");
    let type = _.get(this.props, "match.params.type", "")
    let requestId = _.get(this.props, "match.params.requestId", "")
      contentRequestServices.getContentRequestIds(contentId.substring(0, 24)).then((res) => {
        const { requestIds = [] } = res;
        if (requestIds.length) {
          this.setState({
            contentRequestIds: { ...res },
          })
        }
      })
    if (subType === 'notes') {
      contentService.detailsNTL(contentId).then((res: any) => {
        
        let content_Id = res._id;
        this.props.setNotesData({ title: res.title });
        if (res.content.pages && res.content.pages.length) {
          res.content.pages.forEach((element: any) => {
            let pageKey = `page${element.pageNumber}`;
            if (element.type === 'QUESTION') {
              this.props.tabClicked(3, element.pageNumber);
              let attemptQuestion = element.metaData.question.attempt || false;

              this.props.setNotesData({
                attempt: {
                  ...this.props.notesData.attempt,
                  [pageKey]: attemptQuestion
                }
              })
              let contentId = element.metaData.question.id.contentId || "";
              let instruction = element.metaData.question.instruction || "";
              let title = element.metaData.question.id.content[0].questionContent || "";
              let questionId = element.metaData.question.id._id || "";
              let subHeading = element.metaData.question.subHeading || '';
              let passageId = element.metaData.question.passageId || "";
              this.setState({
                pageState: {
                  ...this.state.pageState, [pageKey]: {
                    ...this.state.pageState[pageKey],
                    ['question']: {
                      searchId: contentId,
                      title: title,
                      addInstruction: instruction,
                      content_Id: questionId,
                      attempt: attemptQuestion,
                      subHeading,
                      passageId
                    },
                    ['theory']: {
                      ...initialTheoryState
                    },
                    ['video']: {
                      ...initialVideoState
                    },
                    ['audio']: {
                      ...initialAudioState
                    },
                    ['pageContentType']: 'Question'
                  }
                }
              }, () => {
                this.setUpdatedPagesNotesData()
              })
            }
            else if (element.type === 'THEORY') {
              this.props.tabClicked(1, element.pageNumber);
              let text = element.metaData.theory.content;
              text = text.replace(/(&nbsp;|<([^>]+)>)/ig, '');
              let isPageFull = false;
              if (text.length >= 1000) {
                isPageFull = true;
              }
              this.setState({
                pageState: {
                  ...this.state.pageState, [pageKey]: {
                    ...this.state.pageState[pageKey],
                    ['theory']: {
                      theoryDescription: element.metaData.theory.content || '',
                      isPageFull,
                      subHeading: (element.metaData.theory || {}).subHeading
                    },
                    ['question']: {
                      ...initialQuestionState,
                    },
                    ['video']: {
                      ...initialVideoState,
                    },
                    ['audio']: {
                      ...initialAudioState,
                    },
                    ['pageContentType']: 'Theory'
                  }
                }
              }, () => {
                this.setUpdatedPagesNotesData()
              })
            }
            if (element.type === 'VIDEO') {
              this.props.tabClicked(5, element.pageNumber);
              this.setState({
                pageState: {
                  ...this.state.pageState, [pageKey]: {
                    ...this.state.pageState[pageKey],
                    ['video']: {
                      contentId: element.metaData.video.contentId || null,
                      id: element.metaData.video.id || null,
                      videoURL: element.metaData.video.uri || '',
                      videoTitle: element.metaData.video.title || '',
                      videoDescription: element.metaData.video.description || '',
                      subHeading: (element.metaData.video || {}).subHeading
                    },
                    ['question']: {
                      ...initialQuestionState,
                    },
                    ['theory']: {
                      ...initialTheoryState,
                    },
                    ['audio']: {
                      ...initialAudioState,
                    },
                    ['pageContentType']: 'Video'
                  }
                }
              }, () => {
                this.setUpdatedPagesNotesData()
              })

            }
            if (element.type === 'AUDIO') {
              this.props.tabClicked(4, element.pageNumber);
              this.setState({
                pageState: {
                  ...this.state.pageState, [pageKey]: {
                    ...this.state.pageState[pageKey],
                    ['audio']: {
                      contentId: element.metaData.audio.contentId || null,
                      id: element.metaData.audio.id || null,
                      videoURL: element.metaData.audio.uri || '',
                      videoTitle: element.metaData.audio.title || '',
                      videoDescription: element.metaData.audio.description || '',
                      subHeading: (element.metaData.audio || {}).subHeading
                    },
                    ['question']: {
                      ...initialQuestionState,
                    },
                    ['theory']: {
                      ...initialTheoryState,
                    },
                    ['video']: {
                      ...initialVideoState,
                    },
                    ['pageContentType']: 'Audio'
                  }
                }
              }, () => {
                this.setUpdatedPagesNotesData()
              })

            }
            if( element.type === 'PDF') {
              this.props.handleNotesData({activeTab: "Upload PDF"});
               
              let url = element.metaData.pdf.url ? JSLZString.decompressFromEncodedURIComponent(element.metaData.pdf.url) : '';

              this.props.handleNotesData({pdfUrl: url});
              
            }


          });
        }
        this.props.setNotesData({ _id: content_Id, ...res });
        this.setState({
          // notesData: { ...this.state.notesData, _id: content_Id, ...res },
          content: { ...this.state.content, content: res }
        });
       this.getValidationDetails();
       this.state.updateTabState();
      })

    }
    if (!contentId) {
      contentId = getContentId();
      if (contentId) {
        if (_.get(this.props, "match.params.type", "") == "studymaterial") {
          if (_.get(this.props, "match.params.subType", "") == "notes") {
            contentId += _.get(this.props, "match.params.type", "");
          } else {
            contentId += _.get(this.props, "match.params.subType", "");
          }
        } else {
          contentId += _.get(this.props, "match.params.type", "");
        }
      }
    }
    let searchQuery = _.get(this.props, "location.search", "");
    let urlParams = new URLSearchParams(searchQuery);
    if (urlParams.has("questionId")) {
      const questionId: any = urlParams.get("questionId");
      const sectionIndex: any = urlParams.get("sectionIndex");
      const subSectionIndex: any = urlParams.get("subSectionIndex");
      contentService.getQuestion(questionId).then((res: any) => {
        if (res) {
          const originalFormData = this.getDefaultQuestionData(res);
          this.setState({
            backFromQuestion: true,
            questionData: res,
            questionSectionIndex: sectionIndex,
            questionSubSectionIndex: subSectionIndex,
            originalFormData
          });
        }
      });
    }
    this.setState({ loadingFormData: false })
    if (!_.isEmpty(contentId)) {
      this.setState({ loadingFormData: true })
      contentService.detailsNTL(contentId).then((res: any) => {
        if(this.props.fromFeedback){
          this.props.getFeedback(this.props.contentRequestId, res.content_Id, 1);
        }
        if (res) {
          const {contentTypeCode = '', aclMetaData = {}, subjects = []} = res;
          if(contentTypeCode === 'testpapers') {
            this.setState((prevState) => ({
             ...prevState,
             alreadyAddedQuestions: {
              aclMetaData,
              subjects,
             }
            }));
          }
          const originalFormData = this.getDefaultQuestionData(res);
          this.setState({ originalFormData });
          if ((res.specialPurposes || []).includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
            contentService.getSpecialPurposeCourses(CONTENT_SPECIAL_PURPOSES.FTRE).then((res) => {
              res.forEach((data: any)=>{
                data.id = data._id;
              });
              this.props.setFtreRelevantExam(res);
            });
            contentService.getSpecialPurposeCourses(CONTENT_SPECIAL_PURPOSES.RELEVANT_EXAMS).then((res) => {
              res.forEach((data: any)=>{
                data.id = data._id;
              });
              this.props.setAllRelevantExams(res);
            });
            contentService.getSpecialPurposeCourses(CONTENT_SPECIAL_PURPOSES.PREVIOUS_YEAR).then((res) => {
              res.forEach((data: any)=>{
                data.id = data._id;
              });
              this.props.setAllPreviousExams(res);
            });
          }
        }
        // get content history 
        contentService
          .getContentHistory(res.content_Id,
            //@ts-ignore
            contentTypesForContentHistoryMap[_.get(this.props, "match.params.type", "")])
          .then((res: any) => {
            this.setState({
              contentHistory: res
            })
            if (_.get(this.props, "match.params.subType", "") === 'notes') {
              res = [];
              this.setState({ contentHistory: res })
            }
            if (_.get(this.props, "match.params.subType", "") === 'videos') {
              res = [];
              this.setState({ contentHistory: res })
            }
            if (_.get(this.props, "match.params.subType", "") === 'audios') {
              res = [];
              this.setState({ contentHistory: res })
            }

          });
        const questionSubType = _.get(this.props, "match.params.subType", "");
        //change courseId for test
        if (_.get(this.props, "match.params.type", "") == 'question' && questionSubType != '5') {

          this.props.setTitle(_.get(res, 'title', ''))
          if (res.content.content[0] && res.content.content[0].optionsContent) {
            this.props.setOptionsContent(res.content.content[0].optionsContent)
          }

          if (res.content.content[0] && res.content.content[0].matrixOptionContent) {
            this.props.setMatrixOptionsContent(res.content.content[0].matrixOptionContent)
          }
          if (res.content.content[0] && res.content.content[0].correctAnswer) {
            this.props.setCorrectAnswer(res.content.content[0].correctAnswer)
          }
          if (res.content.content[0] && res.content.content[0].customAnswer) {
            this.props.setCustomAnswer(res.content.content[0].customAnswer)
          }
          const previousExams=_.get(res,"content.previousExams",[]);
          if(previousExams.length>0){
            this.setPreviousExams(previousExams,contentId);
          }
          // if (res.content && res.content.relevantExams) {
          //   this.props.setRelevantExams(res.content.relevantExams);
          // }

          // if (res.masterVariationQuestionData && res.masterVariationQuestionData.relevantExams) {
          //   this.props.setRelevantExams(res.masterVariationQuestionData.relevantExams)
          // }

          const stepWiseSolution: StepWiseSolution[] = _.get(res, 'content.content[0].stepWiseSolution');
          const solutionContent = _.get(res, 'content.content[0].solutionContent', '');
          if (stepWiseSolution && stepWiseSolution.length > 0) {
            this.props.setStepWiseSolutions([stepWiseSolution]);
          } else if (solutionContent) {
            // for older questions where solutionContent exists but stepWiseSolution doesnt
            // make solutionContent as step 1
            const stepWiseSolution = [{
              formulaUsed: "",
              solutionSteps: [{
                weightage: QUESTION_TYPES.DESCRIPTIVE.toString() === questionSubType ? 100 : undefined,
                solution: solutionContent,
                stepNo: 1
              }]
            }]
            this.props.setStepWiseSolutions([stepWiseSolution])
          }
          // solutionContent is replaced by stepWiseSolution
          this.props.setSolutionContent(solutionContent)

          this.props.setQuestionHints(_.get(res, 'content.content[0].questionHints', ''))
          const updatedAt = _.get(res, 'updatedAt');
          const createdAt = _.get(res, 'content.createdAt');

          this.props.setSubjects(_.get(res, 'subjects', []))
          this.props.setSecondarySubjects(_.get(res, 'secondarySubjects', []))
          this.props.setDifficultyLevel(_.get(res, 'difficultyLevel', []))
          this.props.setDifficultyType(_.get(res, 'difficultyType', []))
          this.props.setTags(_.get(res, 'content.tags', []))
          this.props.setSpecialPurposes(_.get(res, 'specialPurposes', []));
          this.props.setDraftId(res.content.draftId);
          let idealTimeToSolve = _.get(res, 'content.settings.idealTimeToSolve', '')
          this.props.setIdealTime({ value: getTime(idealTimeToSolve, true), state: getTimeUnit(idealTimeToSolve, true) })
          if(createdAt !== updatedAt) {
              // Just added out of call stack so that all mount oprations are done
              setTimeout(() => {
                if (this.props && this.props.validations) {
                  let validationsCopy = JSON.parse(JSON.stringify(this.props.validations))
                  if (_.get(res, 'subjects', []).length) {
                    validateSyllabus(validationsCopy, _.get(res, 'subjects', []))
                  }
    
                  if (res.content.content[0] && _.get(res, 'content.content[0].correctAnswer.data', []).length) {
                    validateAnswer(validationsCopy, res.content.content[0].correctAnswer,
                      res.masterVariationQuestionId
                        ? _.get(res.masterVariationQuestionData, 'questionCode', '').toString()
                        : res.contentSubTypeCode.toString())
                  }
                  this.props.setValidations(validationsCopy)
                }
              })
              /* Todo -find a better way for this as in react onChnage not trigger 
              when value change from state or props
              */
              setTimeout(() => {
                if (_.get(res, 'content.tags', []).length) {
                  let validationsCopy = JSON.parse(JSON.stringify(this.props.validations))
                  validateTags(validationsCopy, this.props.tagsList, _.get(res, 'content.tags', []))
                  this.props.setValidations(validationsCopy)
                }
              }, 3000)
          }
          if ([
            QUESTION_TYPES.SMCQ,
            QUESTION_TYPES.INTEGER,
            // added more
            QUESTION_TYPES.BLANKS,
            QUESTION_TYPES.DESCRIPTIVE,
            QUESTION_TYPES.MATRIX,
            QUESTION_TYPES.MMCQ,
            QUESTION_TYPES.NUMERICAL,
            QUESTION_TYPES.TRUE_FALSE
          ].includes(parseInt(res.content.questionCode)) && res.content.status === CONTENT_STATES.PUBLISHED) {
            contentService.getQuestionAttemps({ questionIds: [res.content_Id] }).then((res: any) => {
              // Note - valid attemps allways reading from here for paragraph as well 
              this.props.setIsValidAttempts(res.hasValidAttempts)
              this.setState({ hasMyLibraryQueue: res.hasMyLibraryQueue })
              // this.props.setIsValidAttempts(true);
            });
            this.props.setDefaultCorrectAnswer(res.content.content[0].correctAnswer)
          }
        }

        if (_.get(res, 'content.contentSubTypeCode') === QUESTION_TYPE_CODE.PARAGRAH) {
          _.get(res, 'content.content', []).forEach((contentData: any) => {
            this.props.setSelectedGoals({ [contentData.paragraphQuestionId || '']: contentData.syllabusExams || [] });
          });
        } else {
          const questionId = _.get(res, 'content_Id', '');
          this.props.setSelectedGoals({ [questionId]: _.get(res, 'syllabusExams', []) });
        }
        if (_.get(this.props, "match.params.type", "") == 'question') {

          if (res.content && res.content.syllabusExams && res.content.questionCode !== 5) {
            this.props.setSyllabusExams({ qId: res.content._id, selectedExams: res.content.syllabusExams });
          } else if (res.content.questionCode === 5) {
            res.content.content.forEach((content: any) => {
              this.props.setSyllabusExams({ qId: content.paragraphQuestionId, selectedExams: content.syllabusExams });
            })
          }

          if (res.content && res.content.relevantExams) {
            this.props.setRelevantExams(res.content.relevantExams);
          }

          if (res.masterVariationQuestionData && res.masterVariationQuestionData.relevantExams) {
            this.props.setRelevantExams(res.masterVariationQuestionData.relevantExams)
          }
          if ([
            QUESTION_TYPES.PARAGRAPH
          ].includes(parseInt(res.content.questionCode)) && res.content.status === CONTENT_STATES.PUBLISHED) {
            contentService.getQuestionAttemps({ questionIds: [res.content_Id] }).then((res: any) => {
              // Note - valid attemps allways reading from here for paragraph as well 
              this.props.setIsValidAttempts(res.hasValidAttempts)
              // this.props.setIsValidAttempts(true);
            });
            // TODO add paragraph type check later 
            if (res.content.content) {
              // for paragraph questions only 
              const allCorrectAnswer: any[] = []
              res.content.content.forEach((data: any) => {
                data.correctAnswer.data.forEach((_data1: any) => {
                  delete _data1._id
                })

                allCorrectAnswer.push(JSON.parse(JSON.stringify(data.correctAnswer)))
              })
              this.setState({ defaultCorrectAnswersForParagraph: allCorrectAnswer })
            }
          }
          if(subType=='5'){
            this.props.setSpecialPurposes(_.get(res, 'specialPurposes', []));
             _.get(res,"content.content",[]).forEach((c:any)=>{
              const previousExams=_.get(c,"previousExams",[]);
              if(previousExams.length>0){
                this.setPreviousExams(previousExams,c.paragraphQuestionId);
              }
            });
          }
        }
        if (_.get(res, "content.courseId[0]._id", null)) {
          // res.content.courseData = res.content.courseId[0]
          res.content.courseId[0] = _.get(res, "content.courseId[0]._id");
        }

        if (_.get(this.props, "match.params.type", "") == 'testpapers') {
          contentService.getTestAttemps({ testIds: [res.content_Id] })
            .then((attamps: any) => {
              this.setState({
                isTestAttampted: attamps.hasValidAttempts, testAttemptData: attamps.data,
                hasMyLibraryQueue: attamps.hasMyLibraryQueue
              })
            })
        }
        let formData = _.get(res, 'content', {});
        if(_.get(this.props, "match.params.type", "") == 'question') {
          // If settings.option is missing then include it
          if(formData.settings && !formData.settings.option) {
            formData.settings.option = {
              displayCount: 4,
              shuffleType: "same"
            }
          }

          formData.content.forEach(((c: any) => {
            c.active = false
            c.settings = _.get(c, 'settings', {})
            if(!c.settings.option) {
              c.settings.option = {
                displayCount: 4,
                shuffleType: "same"
              }
            }
          }))
        }
        let allowedTo = _.get(formData, 'aclMetaData.allowedTo', []);
        let email = _.get(formData, 'aclMetaData.createdBy.email', '');
        let module =  _.get(this.props, "match.params.type", "");
        if ([AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS, AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION].includes(module)){
          let permissionType = (formData.specialPurposes && formData.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE;
          module = (module === AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION) ? MODULE_TO_QUESTION_PERMISSION_MAP[permissionType] : MODULE_TO_TEST_PERMISSION_MAP[permissionType];
        }
        const editRights =  getEditRights(allowedTo, module, email, formData.aclMetaData);
        this.props.setEditRights(editRights);
        if (_.get(this.props, "match.params.type", "") == 'question' && _.get(this.props, "match.params.subType", "") == '5') {
          const allContent = _.get(formData, 'content', []);
          let resultIds = allContent.map((data: any) => data.paragraphQuestionId);
          resultIds = resultIds.join(',');
          if(this.props.fromFeedback) {
          this.props.getFeedback(this.props.contentRequestId, resultIds, 1);
          }
          const stepWiseSolutions = allContent.map(({ stepWiseSolution }: { stepWiseSolution: StepWiseSolution[] }) => {
            return stepWiseSolution;
          });

          this.props.setStepWiseSolutions(stepWiseSolutions);
          formData.content.map(((c: any) => {
            c.active = false
            c.settings = _.get(c, 'settings', {})
            let idealTimeToSolve = c.settings.idealTimeToSolve
            c.settings.idealTime = { value: getTime(idealTimeToSolve, true), state: getTimeUnit(idealTimeToSolve, true) }
          }))
        }
        formData.subjects = _.get(res, 'subjects', []);
        formData.secondarySubjects = _.get(res, 'secondarySubjects', []);
        if (_.get(this.props, "match.params.subType", "") === 'videos') {
          const pageState = this.getFormDataState(formData);
          formData.pageState = pageState;
          formData.videoKey = _.get(res, 'videoUrl', '');
          formData.videoUrl = _.get(res, 'content.videoUrl', '');
          formData.thumbnailUrl = _.get(res, 'content.thumbnailUrl', '');
          this.props.setVideoDetailsData({ ...formData, pageState });
        }
        if (_.get(this.props, "match.params.subType", "") === 'audios') {
          const pageState = this.getFormDataState(formData);
          formData.pageState = pageState;
          formData.audioKey = _.get(res, 'audioUrl', '');
          formData.audioUrl = _.get(res, 'content.audioUrl', '');
          formData.thumbnailUrl = AudioUrlImage;
          this.props.setAudioDetailsData({ ...formData, pageState });
        }
        this.setState(() => ({
          loadingFormData: false,
          formData: { ...this.state.formData, ...formData },
          content: JSON.parse(JSON.stringify({ ...this.state.content, ...res })),
        }));
       const alternateAnswer = _.get(res,'content.content[0].alternateAnswer');
       this.props.setalternateAnswer(alternateAnswer);    

        setTimeout(() => {
          this.props.eventFired("Edit", 0, 0, 0);
          this.getValidationDetails();
        }, 50);

        this.state.updateTabState();
      });
    }
  }


  getDefaultQuestionData(questionData: any) {
    const { originalFormData } = this.state;
    let newFormData = makeDeepCopy(originalFormData);
    try {
      if (questionData.contentSubTypeCode === QUESTION_TYPE_CODE.PARAGRAH) {
        newFormData.content = contentForPassageTypeQuestion(questionData.content.content.length);
      }
    } catch (error) {
      newFormData = makeDeepCopy(originalFormData);
    }
    return newFormData;
  }

  secondsToTime = (totalSeconds: any) => {
    var hours = Math.floor(totalSeconds / (60 * 60));

    var divisor_for_minutes = totalSeconds % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);

    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);

    var obj = {
      "HH": (hours <= 9) ? `0${hours}` : `${(hours)}`,
      "MM": (minutes <= 9) ? `0${minutes}` : `${(minutes)}`,
      "SS": (seconds <= 9) ? `0${seconds}` : `${(seconds)}`
    };
    return obj;
  }


  getFormDataState = (formData: any) => {
    const { pages = [] } = formData;
    let pageState: any = {}
    pages.length && pages.forEach((page: any = {}) => {
      const { pageNumber, metaData } = page
      const totalSeconds = metaData.question.showQuestionAtTime || 0;
      const { SS = '00', HH = '00', MM = '00' } = this.secondsToTime(totalSeconds);
      pageState[`question${pageNumber}`] = {
        attempt: _.get(metaData, 'question.attempt', false),
        content_Id: _.get(metaData, 'question.id._id', ''),
        contentId: _.get(metaData, 'question.id.contentId', ''),
        description: _.get(metaData, 'question.description', ''),
        hours: 0,
        instruction: _.get(metaData, 'question.instruction', ''),
        showHint: _.get(metaData, 'question.additionalOption.showHint', false),
        showQuestionAtTime: `${HH}:${MM}:${SS}`,
        showSolution: _.get(metaData, 'question.additionalOption.showSolution', false),
        title: _.get(metaData, 'question.id.content[0].questionContent', ''),
      }
    });
    return pageState;
  }

  setSectionCurrentlyEditing = (sectionName: string) => {
    this.setState({
      sectionCurrentlyEditing: sectionName
    })
  }

   handleFormChange(formUpdateData: ContentFormData, sectionName?: string) {
    if (formUpdateData.content && formUpdateData.content[0] && formUpdateData.content[0].optionsContent && formUpdateData.content[0].optionsContent.length > 0) {
      this.state.formData.content[0].optionsContent = formUpdateData.content[0].optionsContent
    }
    const isSaveRequired = _.isUndefined(this.state.formData.totalQuestion) && !_.isUndefined(formUpdateData.totalQuestion);
     this.setState((prevState) => {
      return {
        ...prevState,
        formData: { ...prevState.formData, ...formUpdateData },
        sectionCurrentlyEditing: sectionName || ''
      }
    }, () => {
      if (isSaveRequired) {
        this.debouncedSave(true, () => window.location.reload());
      }
    });
    // TODO: Uncomment once test is completed with state
    // this.debouncedSave(true)
  }
  setPreviousExams=(previousExams:PreviousExamItem[],contentId:string)=>{
    let questionId = contentId ? contentId.split("question")[0] : contentId;
       const allQuestionPreviousExam={..._.get(this.props,"questionPreviousExams",{})};
       let questionPrevExams:PreviousExamItem[]=[];
       let idIndxMap:any={};
       previousExams.forEach((p,indx)=>{
        if(!_.isEmpty(p)){ 
           let i=questionPrevExams.length;
          if(idIndxMap.hasOwnProperty(p.id)){
            i=idIndxMap[p.id];
          } 
           const year=_.get(questionPrevExams,`[${i}].year`,[]);
           year.push(""+p.year);
           questionPrevExams[i]={...p,year:year};
           idIndxMap[p.id]=i;
         }
       });
       this.props.setPreviousExams({questionId,data:questionPrevExams});
  }
  handleOptionSettingsChange = (optionSettingsType: string, value: any, options?: { isParagraph: boolean, index: number }) => {
    if (options && options.isParagraph) {
      const { index } = options;
      this.setState(prevState => {
        const newFormData = { ...prevState.formData };
        const newFormDataContent = [...newFormData.content];
        newFormDataContent[index] = {
          ...newFormDataContent[index],
          settings: {
            ...newFormDataContent[index].settings,
            option: {
              ...newFormDataContent[index].settings.option,
              [optionSettingsType]: value
            }
          }
        }
        newFormData.content = newFormDataContent;
        return {
          ...prevState,
          formData: newFormData
        }
      })
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          formData: {
            ...prevState.formData,
            settings: {
              ...prevState.formData.settings,
              option: {
                ...prevState.formData.settings.option,
                [optionSettingsType]: value
              }
            }
          }
        }
      })
    }
  }
  validatePrevQues=(prevExamsArray:any[])=>{
     return prevExamsArray.find((p)=>_.isEmpty(p.year) && !_.isEmpty(p.id));
  }
  async handleFormSubmit(runInBackground:boolean=false) {
    const { formData } = this.state
    const { type, subType, requestId } = this.props.match.params;
    const{questionPreviousExams}=this.props;
   
    if (type == "question") {
     for(let j=0; j<formData.content.length; j++){
       const questionId=formData.content[j].paragraphQuestionId;
         if(questionPreviousExams[questionId] && this.validatePrevQues(questionPreviousExams[questionId])){ 
            this.props.showMsg("Select atleast one year under Previous Year Question Section","error");
            return ;
         }
       }  
  
      await new Promise(res => {
        this.setState((prevState:ContentCreateStates)=>{
           const{formData}=prevState;
          formData.content.map((c: any) => {
            c.settings.idealTimeToSolve = getTimeInSecs(
              c.settings.idealTime.value,
              c.settings.idealTime.state);
              if(questionPreviousExams && !_.isEmpty(questionPreviousExams[c.paragraphQuestionId])){
                let previousExams:GenericPreviousExamItem[]=[];
                let result=getGenericPrevExams(c.paragraphQuestionId,questionPreviousExams);
                    previousExams=result[0];
                    // if(result[1]){
                    //    this.props.setPreviousExams({questionId:c.paragraphQuestionId, data:result[2]});
                    // }
                c.previousExams=previousExams;
              }
          });
          
         return {formData}; 
        }, async () => {
          await this.save(runInBackground);
          res(true);
        })
      })
    } else {
      await this.save(runInBackground);
    }
  }

  handleFeedbackClick(clickedfeedbackData: any) {
    this.setState({
      clickedfeedbackData: clickedfeedbackData,
      openFeedback: true
    }, () => {
      setTimeout(() => {
  
      if(document.getElementById("feedbackScroll") !== null){
        // @ts-ignore
      document.getElementById("feedbackScroll").scrollIntoView(true);
      }
    }, 200 );
    })

  }

  loadMoreFeedback(pageNumber: number) {
    if (this.state.content && this.state.content.contentTypeCode === 'question') {
      if (this.state.content.contentSubTypeCode === QUESTION_TYPES.PARAGRAPH.toString()) {
        let resultIds = this.state.content.content.content.map((data: any) => data.paragraphQuestionId);
        resultIds = resultIds.join(',');
          this.props.getFeedback(this.props.contentRequestId, resultIds, 1);
      } else {
        this.props.getFeedback(this.props.contentRequestId, this.state.content.content._id, pageNumber)
      }
  }  else {
    this.props.getFeedback(this.props.contentRequestId, this.state.content.content._id, pageNumber)
  }
 }

  validateCustomDescription = (description: any) => {
    let error: any = [];
    const mainContent = description.replace(/(&nbsp;|<([^>]+)>)/ig, '');
    if (mainContent.length > 180) {
      error.push('Question description should not exceed 180 characters')
    }
    return error;
  }

  formatVideoSaveData = (formData: any) => {
    let pages: any[] = [];
    let error = false;
    let newFormData: any = {
      _id: formData._id,
      aclMetaData: formData.aclMetaData,
      authors: formData.authors,
      completionPercent: formData.completionPercent,
      conceptCode: formData.conceptCode,
      concepts: formData.concepts,
      favourites: formData.favourites,
      subjects: formData.subjects,
      secondarySubjects: formData.secondarySubjects,
      tags: formData.tags,
      title: formData.title,
      status: formData.status,
      description: formData.description,
      videoUrl: formData.videoKey,
      thumbnailUrl: formData.thumbnailUrl,
      pages: [],
    };

    formData.pageState && Object.keys(formData.pageState).map((questionName, index) => {
      const pageState = formData.pageState[questionName];
      const questionTime = pageState.showQuestionAtTime || '00:00:00';
      const timeArray = questionTime.split(":");
      const totalSeconds = (parseInt(timeArray[0]) * 60 * 60) + (parseInt(timeArray[1]) * 60) + parseInt(timeArray[2])
      const questionValidationErrors = this.validateCustomDescription(pageState.description)
      if (questionValidationErrors.length) {
        questionValidationErrors.map((error: any) => this.props.showAlert(error, 'error'));
        error = true
        return;
      }
      if (!pageState.content_Id){
        this.props.showAlert(`Please add or remove question ${index+1} to save the study material`, 'error');
        error = true;
        return;
      }
      const page = {
        type: 'QUESTION',
        pageNumber: index + 1,
        metaData: {
          question: {
            id: pageState.content_Id || '',
            title: pageState.title,
            description: pageState.description,
            instruction: pageState.instruction,
            attempt: pageState.attempt || false,
            additionalOption: {
              showSolution: pageState.showSolution || false,
              showHint: pageState.showHint || false
            },
            showQuestionAtTime: totalSeconds
          }
        }
      }
      pages.push(page);
    });
    if (error) {
      return { error }
    }
    newFormData.pages = pages;
    return { newFormData, error };
  }

  saveThumbnail = async (formData: any) => {
    let thumbnail = formData.thumbnailUrl || '';
    try {
      if (thumbnail.length && !thumbnail.startsWith('videos/thumbnail')) {
        thumbnail = await videoUploadService.uploadThumbnailUrl(thumbnail)
      }
      return thumbnail;
    } catch (error) {
      return thumbnail;
    }
  }
  
  setCustomAnswerKey=(formData:ContentFormData)=>{
    const sectionsArray=_.get(formData,"data.sections",[]);
    sectionsArray.forEach((sec:any,index:number)=>{
       sec.subSection.forEach((subSec:any,innerIndx:number)=>{
            if(subSec.quesCodeAllowed===7){  
               subSec.customAnswer=false;  
               const customAns=_.get(subSec,"questions",[]).find((q:any)=>{
                  return _.get(q,"qId.content[0].customAnswer",false) ||_.get(q,"content_Id.customAnswer",false) ;
               });
               if(customAns){
                subSec.customAnswer=true;
               }else{
                subSec.customAnswer=false;
               }
            }
            if(index==sectionsArray.length-1 && innerIndx===subSec.length-1){
              return Promise.resolve();
          }   
       });
       if(index==sectionsArray.length-1 && sec.subSection.length==0){
          return Promise.resolve();
       }  
    })
  }

  async save(runInBackground: boolean, callback?: any) {
    const { contentSubtype, allQuestionBenchmarks, updateQuestionBenchmarks,questionPreviousExams } = this.props;
    const { type, subType } = this.props.match.params;
    let { content, formData } = this.state;
    let contentTypeCode = type;
    //setting type for question type 
    if (type == "question") {
      formData.relevantExams = this.props.relevantExams;
      formData.questionCode = parseInt(subType);
      _.get(contentSubtype, "question", []).forEach(st => {
        if (subType == parseInt(st.code)) {
          formData.questionType = st.name;
        }
      });
      if (!_.isEmpty(allQuestionBenchmarks)) {
        Object.keys(allQuestionBenchmarks).forEach(questionId => {
          updateQuestionBenchmarks({ questionId })
        })
      }
      if (+subType === QUESTION_TYPES.PARAGRAPH) {
        this.formatDataForParagraphRemedialQuestion(formData);
      } else {
        formData.remedialQuestionIds = this.props.remedialQuestionIds[PROPS_REMEDIAL_KEY.DEFAULT]
      }
    }

    if (type == "testpapers") {
      formData.settings = {
        ...formData.settings,
        testType: subType
      }
      await this.setCustomAnswerKey(formData);
    }

    let formDataCopy: any = { ...formData }
    if (type === "studymaterial" && subType === "videos") {
      contentTypeCode = subType;
      const thumbnail = await this.saveThumbnail(formData);
      formDataCopy.thumbnailUrl = thumbnail;
      const { newFormData, error } = this.formatVideoSaveData(formDataCopy);
      if (error) return;
      formDataCopy = newFormData;
    }
    if (type === "studymaterial" && subType === "audios") {
      contentTypeCode = subType;
      const thumbnail = await this.saveThumbnail(formData);
      formDataCopy.thumbnailUrl = thumbnail;
      const { newFormData, error } = this.formatVideoSaveData(formDataCopy);
      if (error) return;
      formDataCopy = newFormData;
    }
    if(type === 'studymaterial' && subType === "formulas") {
      contentTypeCode = subType
    }
    if (this.state.passageId) {
      formDataCopy.passageId = this.state.passageId
      formData.content.forEach((el: any, index: number) => {
        if (index >= this.state.contentForParagraph.length) {
          return '';
        }
        if (index === 0) {
          formDataCopy.content[index] = {
            ...formDataCopy.content[index],
            isParagraphRootNode: this.state.contentForParagraph[index].isParagraphRootNode,
            paragraphQuestionId: this.state.contentForParagraph[index].paragraphQuestionId
          }
        } else {
          formDataCopy.content[index] = {
            ...formDataCopy.content[index],
            paragraphQuestionId: this.state.contentForParagraph[index].paragraphQuestionId
          }
        }
      });
    }
    if (type === "question" && subType == '5') {
      formDataCopy.content = formDataCopy.content.map((form: any, index: number) => ({
        ...form,
        syllabusExams: formData.content[index].syllabusExams
      }))
    }
    return contentService
      .save(content._id, contentTypeCode, formDataCopy, runInBackground, {type, subType})
      .then((response: any) => {
        let res = response.responseObject || {}
        if (res.video && contentTypeCode === 'videos') {
          res = res.video;
          formData.thumbnailUrl = formDataCopy.thumbnailUrl;
        }
        let requestId = _.get(this.props, "match.params.requestId", "")
        if (res.passageId) {
          let contentForParagraph: any = []
          if (res.content) {
            contentForParagraph = [...res.content]
          }
          this.setState({ passageId: res.passageId, contentForParagraph })
        }
        if (formData) {
          formData.lockData = {
            isLock: res.isLock,
            message: response.responseMessage
          }
        }
        if (res.draftId) {
          formData.draftId = res.draftId
          this.setState({ formData: { ...formData } })
        }
        content.updatedAt = res.updatedAt;
        this.props.setPublishedContent(res)
        this.props.setRequiresForceSaveForChallenge(false);
        const isTeacher = checkForTeacherUser(content);
        const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
        if (res.draftId &&  res.draftId._id && (isTeacher || isCreatorTeacher) && content.status === CONTENT_STATES.PUBLISHED) {
          let {draftContentFormData} = this.state;
          draftContentFormData = {...formData};
          draftContentFormData._id = res.draftId._id;
          draftContentFormData.contentId = res.draftId.contentId;
          draftContentFormData.passageId = res.draftId.passageId;
          draftContentFormData.publishId = res._id;
          this.setState({draftContentFormData});
        }
        return new Promise((resolve, reject) => {
          this.setState({ formData: { ...this.state.formData, ...formData }, content: content }, () => {
            callback && callback();
            resolve(res);
          });
        });
      });
  }

  setNotesPdfFile(attachemnts: Attachment[]) {
    this.setState({
      notesPdfAttachment: attachemnts,
    })
  }

  showRemedialQuestion() {
    const { questionSpecialPurposes } = this.props;
    const contentSpecialPurpose = CONTENT_SECTION_TYPES.filter(section => (questionSpecialPurposes || []).includes(section.value));
    return !contentSpecialPurpose.length;
  }

  getCreateComponent(actionType: any) {
    const { type, subType } = this.props.match.params;
    const {
      formData,
      formDataError,
      content,
      questionData,
      backFromQuestion,
      isTestAttampted,
      testAttemptData,
      hasMyLibraryQueue,
      openFeedback,
      clickedfeedbackData,
      activeValidationFeedbackSection,
      activeValidationFeedbackData,
      feedbackReplyId,
      alreadyAddedQuestions
    } = this.state;
    const { contentSubtype, match, history, authorType, sliderData, contentRequestId } = this.props;
    //if you change here change in edit link also
    //contentService.editLink
    switch (type) {
      case "testpapers": {
        return (
          <TestPaperCreate
            match={match}
            history={history}
            formData={formData}
            setSectionCurrentlyEditing={this.setSectionCurrentlyEditing}
            formDataError={formDataError}
            handleFormChange={this.handleFormChange.bind(this)}
            subType={subType}
            questionData={questionData}
            backFromQuestion={backFromQuestion}
            content={content}
            componentCleanup={this.componentCleanup}
            isTestAttampted={isTestAttampted}
            testAttemptData={testAttemptData}
            hasMyLibraryQueue={hasMyLibraryQueue}
            setHasMylibraryQueue={this.setHasMylibraryQueue}
            openFeedback={openFeedback}
            authorType={authorType}
            contentRequestId={contentRequestId}
            contentRequestItemId={sliderData && sliderData._id}
            clickedfeedbackData={clickedfeedbackData} 
            closeFeedback={this.closeFeedback}
            emptyClickedData={this.emptyClickedData}
            handleFeedbackResolve={this.handleFeedbackClick}
            feedbackData={this.props.feedBackData}
            alreadyAddedQuestions={alreadyAddedQuestions}
          />
        );
      }

      case "studymaterial": {
        switch (subType) {
          case "notes": {
            return (
              <StudyCreate
                history={history}
                actionType={actionType}
                type={type}
                subType={subType}
                setNotesPdfFile={this.setNotesPdfFile}
                updateStatusTab={this.updateActiveStatusTab}
              />
            );
          }
          case "formulas": {
            return (
              <FormulaCreate
                history={history}
                formData={formData}
                formDataError={formDataError}
                handleFormChange={this.handleFormChange.bind(this)}
                type={type}
                subType={subType}
              />
            );
          }
          case "audios": {
            return (
              <StudyNotesCreate
                history={history}
                actionType={actionType}
                formData={formData}
                formDataError={formDataError}
                handleAudioDetailsData={this.handleAudioDetailsData}
                type={type}
                subType={subType}
              />
            );
          }
          case "videos": {
            return (
              <AddDetailsVideo
                history={history}
                actionType={actionType}
                formData={formData}
                formDataError={formDataError}
                handleVideoDetailsData={this.handleVideoDetailsData}
                type={type}
                subType={subType}
              />
            );
          }
          case "sampleproblem": {
            return (
              <SampleProblem
                history={history}
                formData={formData}
                formDataError={formDataError}
                handleFormChange={this.handleFormChange.bind(this)}
                type={type}
                subType={subType}
              />
            );
          }
        }
      }

      case "question": {
        switch (subType) {
          case "0":
          case "1":
          case "2":
          case "4":
          case "3":
          case "6":
          case "7":
          case "8": {
            return (
              <MultipleChoiceCreate
                history={history}
                content={content}
                contentId={match.params.contentId}
                optionSettings={formData.settings.option || {}}
                handleOptionSettingsChange={this.handleOptionSettingsChange}
                // formData={JSON.parse(JSON.stringify(formData))}
                // formDataError={formDataError}
                // handleFormChange={this.handleFormChange.bind(this)}
                type={type}
                status={formData.status}
                subType={subType}
                hasMyLibraryQueue={hasMyLibraryQueue}
                openFeedback={openFeedback}
                authorType={authorType}
                contentRequestId={contentRequestId}
                contentRequestItemId={sliderData && sliderData._id}
                clickedfeedbackData={clickedfeedbackData} 
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                feedbackActionId={feedbackReplyId}
                goalMandatory
                activeValidationFeedbackSection={activeValidationFeedbackSection}
                activeValidationFeedbackData={activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                showRemedial = {this.showRemedialQuestion()}
              />
            );
          }
          // case "1": {
          //   return (
          //     <MatrixCreate
          //       history={history}
          //       formData={formData}
          //       formDataError={formDataError}
          //       handleFormChange={this.handleFormChange.bind(this)}
          //       type={type}
          //       subType={subType}
          //     />
          //   );
          // }
          case "5": {
            return (
              <ParagraphCreate
                history={history}
                contentId={match.params.contentId}
                formData={formData}
                content={content}
                formDataError={formDataError}
                handleFormChange={this.handleFormChange.bind(this)}
                handleOptionSettingsChange={this.handleOptionSettingsChange}
                type={type}
                subType={subType}
                openFeedback={openFeedback}
                authorType={authorType}
                contentRequestId={contentRequestId}
                contentRequestItemId={sliderData && sliderData._id}
                clickedfeedbackData={clickedfeedbackData} 
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                fromFeedback={this.props.fromFeedback}
                activeValidationFeedbackSection={activeValidationFeedbackSection}
                activeValidationFeedbackData={activeValidationFeedbackData}
                feedbackActionId={feedbackReplyId}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                selectedQuestionRef={this.state.selectedQuestionRef}
                showRemedial = {this.showRemedialQuestion()}
              />
            );
          }
        }
      }
    }
  }

  handleAddCommentInFeedback = (comment: string, actionType: string, editLast: boolean = false) => {
    const userData = JSON.parse(localStorage.getItem('patmy') || '');
    const userId = _.get(userData, 'authenticatedUser._id', '');
    const { activeValidationFeedbackSection, activeValidationFeedbackIndex,content } = this.state;
    const currValidationFeedbacks = this.state.validationFeedbacks;
    const newActionObj = {
      comment,
      userId,
      "authorAction": actionType,
      "date": NEW_FEEDBACK_TIME_TO_SHOW,
    };
    const feedbackId = currValidationFeedbacks[activeValidationFeedbackIndex]._id;
    const newFeedbackPayload: any = {
      comment,
      feedbackId,
      action: actionType,
      contentId: currValidationFeedbacks[activeValidationFeedbackIndex].contentId,
      contentSubType: getPropertyValue(content, 'content.questionType')
    };
    if (editLast) {
      newFeedbackPayload['updateAction'] = true;
    }
    contentRequestServices.submitAuthorAction(newFeedbackPayload).then((res) => {
      currValidationFeedbacks[activeValidationFeedbackIndex].status = actionType;
      if (editLast) {
        currValidationFeedbacks[activeValidationFeedbackIndex].actions.pop();
      }
      currValidationFeedbacks[activeValidationFeedbackIndex].actions.push(newActionObj);
      this.setState((prevState: any) => ({
        validationFeedbacks: currValidationFeedbacks,
        activeValidationFeedbackSection: '',
        activeValidationFeedbackIndex: -1,
        activeValidationFeedbackData: {},
      }));
      this.checkPendingValidationComments();
    })
  };

  createNewValidationFeedback = (section: string, feedbackIndex: number = -1, feedbackData: any = {}, feedbackId: string = '') => {
    if (feedbackIndex !== -1) {
      feedbackData = this.state.validationFeedbacks[feedbackIndex];
    }
    this.setState({
      activeValidationFeedbackSection: section,
      activeValidationFeedbackIndex: feedbackIndex,
      activeValidationFeedbackData: feedbackData,
      feedbackReplyId: feedbackId,
    });
  }
  updateCompletionPercent(formData: any, percentage: any, authors: any, status: string) {
    let { formData: formDataState, content } = this.state;
    const { type, subType } = this.props.match.params;
    if (!formData) formData = formDataState;

    formData.completionPercent = percentage;
    content.completionPercent = percentage;
    if (authors) {
      formData.authors = authors;
      content.authors = authors;
    }
    this.setState({
      formData: { ...this.state.formData, ...formData },
      content: content
    });
    if (`${type}_${subType}` === 'studymaterial_videos') {
      this.props.setVideoDetailsData({ completionPercent: percentage });
    }
    if (`${type}_${subType}` === 'studymaterial_audios') {
      this.props.setAudioDetailsData({ completionPercent: percentage });
    }
  }


  checkDisabledConditionForNext() {
    return this.props.feedBackData && this.props.feedBackData.pendingFeedbacksCount !== 0
  }

  deleteContent() {
    this.setState({ isDeleteDialogOpen: true });
  }

  onDeleteConfirmed(action: boolean) {
    const { content, formData } = this.state;
    this.setState({ isDeleteDialogOpen: false });
    if (action == true) {
      content.status = "DELETED";
      this.setState({ content });
    }
  }

  changeFormDataError(errors: ContentFormDataError) {
    this.setState({ formDataError: errors });
  }

  updateFormData(fD: ContentFormData, isSave: boolean = false) {
    if (fD) {
      this.setState({ formData: { ...this.state.formData, ...fD } });
      isSave && this.handleFormSubmit();
    }
  }

  moveToPlanned() {
    let { formData, content } = this.state;
    content.status = "PLANNED";
    formData.status = "PLANNED";
    this.setState({
      formData: { ...this.state.formData, ...formData },
      content: content
    }, () => this.save(true));
  }

  getSidePanelCssClasses(content: any) {
    const { classes } = this.props;
    if (content && content._id) {
      return classes.sidePanel
    }
    return classes.sidePanel2
  }
  handleClick(direction: string) {
    if(direction === "prev") {
    if(this.state.content.contentTypeCode === 'question' && this.props.onContentChange && this.props.currentQuestionNumber) {
      let contentID = `${this.props.sliderData.contents[this.props.currentQuestionNumber - 2].content_id._id}question`;
      this.props.onContentChange(contentID, this.props.currentQuestionNumber - 1, 'question', 'edit');
    } else if(this.state.content.contentTypeCode === 'testpapers' && this.props.onContentChange && this.props.currentTestNumber) {
      let contentID = `${this.props.sliderData.contents[this.props.currentTestNumber - 2].content_id._id}testpapers`;
      this.props.onContentChange(contentID, this.props.currentTestNumber - 1, 'test', 'edit');
    }
    } else {
      if(this.state.content.contentTypeCode === 'question' && this.props.onContentChange && this.props.currentQuestionNumber) {
        let contentID = `${this.props.sliderData.contents[this.props.currentQuestionNumber].content_id._id}question`;
        this.props.onContentChange(contentID, this.props.currentQuestionNumber + 1, 'question', 'edit');
      } else  if(this.state.content.contentTypeCode === 'testpapers' && this.props.onContentChange && this.props.currentTestNumber) {
        let contentID = `${this.props.sliderData.contents[this.props.currentTestNumber].content_id._id}testpapers`;
        this.props.onContentChange(contentID, this.props.currentTestNumber + 1, 'test', 'edit');
      }
    }
    this.closeFeedback('resolve');
  }

  emptyClickedData() {
    this.setState({
      clickedfeedbackData: {}
    })
  }
  switchToPreview() {
    this.props.handlePreviewFromFeedback()
    if(this.state.content.contentTypeCode === 'question' && this.props.onContentChange && this.props.currentQuestionNumber) {
      let contentID = `${this.props.sliderData.contents[this.props.currentQuestionNumber - 1].content_id._id}question`;
      this.props.onContentChange(contentID, this.props.currentQuestionNumber, 'question', 'preview');
    } else if(this.state.content.contentTypeCode === 'testpapers' && this.props.onContentChange && this.props.currentTestNumber) {
      let contentID = `${this.props.sliderData.contents[this.props.currentTestNumber - 1].content_id._id}testpapers`;
      this.props.onContentChange(contentID, this.props.currentTestNumber, 'test', 'preview');
    }
  }
  addFeedbackActive(){
    let clickedfeedbackData = this.props.feedBackData && this.props.feedBackData.feedbacksData.filter((feedback: any) =>
    feedback.tag === 'question' && !feedback.isResolved
    );
    if(clickedfeedbackData && clickedfeedbackData.length > 0) {
      this.setState({
        clickedfeedbackData: clickedfeedbackData[0]
      })
      }
    this.setState({
      openFeedback: true
    }, () => {
      setTimeout(() => {
  
        if(document.getElementById("feedbackScroll") !== null){
          // @ts-ignore
        document.getElementById("feedbackScroll").scrollIntoView(true);
        }
      }, 200 );
    })

  }
  sectionInThisContentStudyMaterial = () => {
    const { classes, history, match, setDraftId, fromFeedback, currentQuestionNumber, feedBackData, currentTestNumber, sliderData, authorType, contentRequestId, questionSpecialPurposes  } = this.props;
    const actionType = !_.isEmpty(
      _.get(this.props, "match.params.contentId", "")
    )
      ? "edit"
      : "create";
    const fromURL = history && history.location && history.location.search;
    const { type, subType } = this.props.match.params;
    const {
      loadingFormData,
      formData,
      formDataError,
      content,
      isDeleteDialogOpen,
      editorId,
      selectedQuestionsList,
      publishedStateQuestion,
      contentHistory,
      defaultCorrectAnswersForParagraph,
      hasMyLibraryQueue,
      sectionCurrentlyEditing,
      notesPdfAttachment,
      canSubmitToAnotherValidator,
      validationStatus,
      pendingValidationComments,
      draftContentFormData,
    } = this.state;

    const isFtre = questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE);
    return (
      <>
        {subType === 'notes' ? (
          <>
            <SectionsInContentStudyMaterial
              completionPercent={this.updateCompletionPercent}
              moveToPlanned={this.moveToPlanned}
              notesData={this.props.notesData}
              handleNotesData={this.handleNotesData}
              content={content}
              queryParams={this.props.match.params}
              history={this.props.history}
              fromURL={fromURL}
              notesPdfAttachment={notesPdfAttachment} 
            />
          </>
        ) :
          (type === 'studymaterial' && subType === 'videos') ? <VideoSectionInContent queryParams={this.props.match.params} completionPercent={this.updateCompletionPercent} formData={formData} save={this.save} />
            :  (type === 'studymaterial' && subType === 'audios') ? <AudioSectionInContent queryParams={this.props.match.params} completionPercent={this.updateCompletionPercent} formData={formData} save={this.save} />
            :
            <SectionsInContent
              completionPercent={this.updateCompletionPercent}
              updateFormData={this.updateFormData}
              moveToPlanned={this.moveToPlanned}
              content={content}
              formData={formData}
              originalFormData={this.state.originalFormData}
              sectionCurrentlyEditing={sectionCurrentlyEditing}
              formDataError={formDataError}
              changeFormDataError={this.changeFormDataError}
              queryParams={this.props.match.params}
              history={this.props.history}
              selectedQuestionsList={selectedQuestionsList}
              publishedStateQuestion={publishedStateQuestion}
              fromURL={fromURL}
              save={this.handleFormSubmit}
              hasMyLibraryQueue={hasMyLibraryQueue}
              defaultCorrectAnswersForParagraph={defaultCorrectAnswersForParagraph}
              fromFeedback={fromFeedback}
              sliderData={sliderData}
              currentQuestionNumber={currentQuestionNumber}
              currentTestNumber={currentTestNumber}
              authorType={authorType}
              feedBackData={feedBackData}
              onFeedbackPublish={this.submitForVerify(contentRequestId, authorType, content.contentTypeCode, (sliderData && sliderData._id), content.content_Id)}
              isFtre={isFtre}
              canSubmitToAnotherValidator={canSubmitToAnotherValidator}
              validationStatus={validationStatus}
              pendingValidationComments={pendingValidationComments}
              draftContentFormData={draftContentFormData}
            />
        }
      </>
    )
  };

  submitForVerify = (contentRequestId: any, role: string, contentType: string, contentRequestItemId: string, content_id: string  ) => { 
    let that = this;
    // contentType = contentType === "testpapers" ? "test" : contentType;
    return async function () {
      try {  
        let { sliderData, currentTestNumber, currentQuestionNumber } = that.props;
        let contentTypeCondition: any = (contentType === 'testpapers' || contentType === 'test') ? currentTestNumber : currentQuestionNumber;  
       if(that.props.authorType !== 'creator'){
       await contentRequestServices.verifyAndNextRequest({
         "contentRequestId": contentRequestId,
         "role": role,
         "contentType": contentType === 'testpapers' ? "test" : contentType,
         "contentRequestItemId": contentRequestItemId,
         "content_id": content_id
       });
      }
       if((sliderData && sliderData.contents && sliderData.contents.length > 1) && (contentTypeCondition < sliderData.contents.length)) {
        that.handleClick('next')
      } else {
        if(that.props.closeReviewContainer) {
          that.props.closeReviewContainer();
        }
      }
     } catch (error) {
       console.log(error);
     }   
    }
};
saveNotes = async (pages: any,runInBackground:boolean=false) => {
  const { notesData,match, showLoader, hideLoader } = this.props;
  const{content,notesPdfAttachment}=this.state;
  const { type, subType, requestId } = match.params;
  const { attempt,activeTab, pdfUrl } = notesData;
  let copyNotesData = setAddConceptAndChapter(notesData);
  if (copyNotesData && copyNotesData.pageError && copyNotesData.pageError.title) {
    this.props.showMsg(copyNotesData.pageError.title, 'error');
  } else {
    delete copyNotesData.pageState;
    delete copyNotesData.pageError;
    delete copyNotesData.attempt;
    delete copyNotesData.activeTab;
    delete copyNotesData.pdfUrl;

    const pageKeyName = Object.keys(notesData.pageState);
    let attachment: any = pdfUrl;
    if(notesPdfAttachment && notesPdfAttachment.length > 0 ) {
      attachment = notesPdfAttachment
    } 
    showLoader();

    let finalPayLoad:any =activeTab==="Upload PDF"? await notePayload(pages, pageKeyName, attempt,attachment): await notePayload(pages, pageKeyName, attempt);
    if(typeof(attachment)=== 'string'&& !_.isEmpty(attachment)){
      finalPayLoad[0].metaData.pdf.code = copyNotesData.content.pages[0].metaData.pdf.code;
      finalPayLoad[0].metaData.pdf.key = copyNotesData.content.pages[0].metaData.pdf.key;
    }
    copyNotesData = { ...copyNotesData, pages: finalPayLoad, completionPercent: Number(copyNotesData.completionPercent), _id: content.content_Id };
   
    
    contentService
    .save(content._id + 'note', 'studymaterial', copyNotesData, runInBackground).
    then((response: any) => {
        hideLoader();
        const res = response.responseObject || {}
        if (res.draftId) {
          this.props.setDraftId(res.draftId)
        }
        content.updatedAt = res.updatedAt;
        this.setState({ content: content });
        // this.props.setContentSuggestions({id:content.content_Id,type:subType});
      })
  }
}
 
formatDataForParagraphRemedialQuestion = (contentDataList: any) => {
    const { content = [] } = contentDataList || {};
    content.forEach((contentObj: any, index: number) => {
      const remedialKey: string = `remedial${index + 1}`;
      if (this.props.remedialQuestionIds[remedialKey]) {
        contentObj.remedialQuestionIds = this.props.remedialQuestionIds[remedialKey];
      }
    });
  };

saveContent = (runInBackground:boolean=false) => {
  const {allQuestionBenchmarks, updateQuestionBenchmarks, notesData,contentSubtype,questionPreviousExams } = this.props;
  const { type, subType, requestId } = this.props.match.params;
  let { formData } = this.state
  let areAllQuestionTypesValid = true;
  const tempPageState = notesData.pageState;
  for(let pageKey in tempPageState){
    const page = tempPageState[pageKey];
    //@ts-ignore
    ((page.pageContentType || '').toLowerCase() === 'question') && (areAllQuestionTypesValid = !!(((page['question'] || {}).content_id || '').trim() || ((page['question'] || {}).content_Id || '').trim()));
  }
  if(!areAllQuestionTypesValid){
    this.props.showAlert("Please add question to save the Note", 'error');
    return;
  }

  if (!_.isEmpty(allQuestionBenchmarks)) {
    Object.keys(allQuestionBenchmarks).forEach(questionId => {
      updateQuestionBenchmarks({ questionId })
    })
  }
  if(type === REMEDIAL_PAGE_KEY.QUESTION && +subType === QUESTION_TYPES.PARAGRAPH){
    this.formatDataForParagraphRemedialQuestion(formData);
  }
  if (subType === 'notes') {
    const { pageState = {} } = notesData;
    const filteredPages = pagesInArrayForm(pageState);
    this.saveNotes([...filteredPages],false);
  }
  else {
    if (type == 'question' && subType != '5') {
      if (!formData.content[0]) {
        formData.content[0] = {}
      }
     let previousExams:GenericPreviousExamItem[]=[];
       
      if(questionPreviousExams && !_.isEmpty(questionPreviousExams[formData._id])){
        if(this.validatePrevQues(questionPreviousExams[formData._id])){
          this.props.showMsg("Select atleast one year under Previous Year Question Section","error");
          return ;
        }
         let result=getGenericPrevExams(formData._id,questionPreviousExams);
            previousExams=result[0];
            // if(result[1]){
            //    this.props.setPreviousExams({questionId:formData._id, data:result[2]});
            // }
      }
      formData.content[0]={
          ...formData.content[0],
          active:  false,
          questionContent : this.props.title,
          questionHints : this.props.questionHints,
          solutionContent : this.props.solutionContent,
          stepWiseSolution : this.props.stepWiseSolution[0],
          optionsContent : this.props.optionsContent,
          matrixOptionContent : this.props.matrixOptionContent,
          correctAnswer : this.props.correctAnswer,
          customAnswer : this.props.customAnswer,
          syllabusExams: this.props.syllabusExams[formData.content[0]._id],

     };
      formData={
           ...formData,
           completionPercent : calCulateProgressBar(this.props.validations, this.props.content).barPercentage,
           //subjects = this.props.subjects
            difficultyLevel : this.props.difficultyLevel,
            difficultyType : this.props.difficultyType,
            relevantExams : this.props.relevantExams,
            tags : this.props.tags,
            subjects : this.props.subjects,
            previousExams:previousExams,
            syllabusExams: this.props.syllabusExams[formData._id],
            remedialQuestionIds: this.props.remedialQuestionIds[PROPS_REMEDIAL_KEY.DEFAULT]
        }

      if (this.props.secondarySubjects) {
        formData.secondarySubjects = this.props.secondarySubjects;
      }

      formData.settings.idealTimeToSolve = getTimeInSecs(this.props.idealTime.value, this.props.idealTime.state)
      formData.questionCode = parseInt(subType);
      _.get(contentSubtype, "question", []).forEach(st => {
        if (subType == parseInt(st.code)) {
          formData.questionType = st.name;
        }
      });
      contentService
        .save(formData._id + 'question', 'question', formData, runInBackground).
        then((response: any) => {
          const res = response.responseObject || {}
          this.props.setPublishedContent(res)
          if (res.draftId) {
            this.props.setDraftId(res.draftId)
          }
          this.props.setRequiresForceSaveForChallenge(false)
        })
    } 
    else {
        if(type=='testpapers'){
          if(formData.previousExam && formData.previousExam.id && !formData.previousExam.year){
            this.props.showMsg("Select atleast one value under Previous Year Test","error");
            return ;
          }
        }
         this.handleFormSubmit(runInBackground);
     }
  }

}
autoSaveContent=()=>{
  const { type, subType } = this.props.match.params;
  if(type !== 'testpapers'){
      // this.saveContent(true);
   }
 }
 getContentSuggestions=(currentSection:string)=>{
  const contentId = _.get(this.props, "match.params.contentId", "");
  const subType = _.get(this.props, "match.params.subType", "");
  const type = _.get(this.props, "match.params.type", "")
  const {formData}=this.state;
  const allowedSection:string[]=["questionContent", "optionsContent","createScenario","createNotes"];
  let sectionArray:string []=[];
  if(subType==5){
    sectionArray=["createQuestion","options"];
  }
  else if (subType === 'notes') {
    sectionArray=['createNotes-page'];
  }
  else if(subType === 'videos'){
    sectionArray=['addDetails'];
  }
  const result= allowedSection.includes(currentSection);
  if(!result){
  const filteredSection=sectionArray.filter((t:string)=>{
    return currentSection.includes(t);
   });
   if(filteredSection.length==0)
    return ; 
  }

  if(type!='testpapers'){
    if(type==='question'){
      const title= subType==5 ?_.get(formData,"content[0].passageQuestion",''):this.props.title;
      if(_.isEmpty(title))
          return;
   } 
     this.props.setContentSuggestions({id:contentId.substring(0, 24),type:type==='studymaterial'?subType:type}); 
  }
 }
  render() {
    const { classes, history, match, setDraftId, fromFeedback, currentQuestionNumber, feedBackData, currentTestNumber, sliderData, prevPath, contentRequestId, authorType } = this.props;
    const actionType = !_.isEmpty(
      _.get(this.props, "match.params.contentId", "")
    )
      ? "edit"
      : "create";
    const fromURL = history && history.location && history.location.search;
    const { type, subType, requestId } = this.props.match.params;
    const {
      loadingFormData,
      formData,
      originalFormData,
      formDataError,
      content,
      isDeleteDialogOpen,
      editorId,
      selectedQuestionsList,
      publishedStateQuestion,
      contentHistory,
      defaultCorrectAnswersForParagraph,
      hasMyLibraryQueue,
      contentRequestIds,
      sectionCurrentlyEditing,
      notesPdfAttachment,
      validationFeedbacks,
      validationEditHistory,
      canSubmitToAnotherValidator,
      validationStatus,
      pendingValidationComments,
    } = this.state;

    const isTeacher = checkForTeacherUser(this.state.content);
    const isStudent = getUserType(USER_TYPE.STUDENT);

    return (
      <ContentSaveContext.Provider value={{autoSave:this.autoSaveContent}}>         
        <CheckDuplicate
        //  autoSave={this.getContentSuggestions}
        />
        <HeaderTool
          match={match}
          history={history}           
          content={content}
          formData={formData}
          originalFormData={originalFormData}
          refreshContent={this.refreshContent}
          editorId={editorId}
          handleFormSubmit={this.handleFormSubmit.bind(this)}
          notesData={this.props.notesData}
          requestId={requestId}
          type={type}
          subType={subType}
          setDraftId={setDraftId}
          defaultCorrectAnswersForParagraph={
            defaultCorrectAnswersForParagraph
          }
          fromFeedback={fromFeedback}
          currentQuestionNumber={currentQuestionNumber}
          prevPath={prevPath}
          currentTestNumber={currentTestNumber}
          sliderData={sliderData}
          handleArrowClick={this.handleClick}
          addFeedbackActive={this.addFeedbackActive}
          previewClicked={this.switchToPreview}
          saveContent={this.saveContent}
          notesPdfAttachment={notesPdfAttachment}
        />
        {loadingFormData ? (
          <MyPATGlobalLoader />
        ) : (
          <div className={`${classes.wrapper} ${classes.root}`}>
            <Grid container spacing={16}>
              <Grid item xs={2}>
                <div className={classes.fixedBox}>
                  {type === "question" && subType != "5" ? (
                    <SectionsInContentQuestion
                      completionPercent={this.updateCompletionPercent}
                      updateFormData={this.updateFormData}
                      moveToPlanned={this.moveToPlanned}
                      content={content}
                      formData={formData}
                      originalFormData={this.state.originalFormData}
                      requestId={requestId}
                      formDataError={formDataError}
                      changeFormDataError={this.changeFormDataError}
                      queryParams={this.props.match.params}
                      history={this.props.history}
                      selectedQuestionsList={selectedQuestionsList}
                      publishedStateQuestion={publishedStateQuestion}
                      fromURL={fromURL}
                      fromFeedback={fromFeedback}
                      sliderData={sliderData}
                      currentQuestionNumber={currentQuestionNumber}
                      currentTestNumber={currentTestNumber}
                      authorType={authorType}
                      feedBackData={feedBackData}
                      onFeedbackPublish={this.submitForVerify(
                        contentRequestId,
                        authorType,
                        content.contentTypeCode,
                        sliderData && sliderData._id,
                        content.content_Id
                      )}
                      canSubmitToAnotherValidator={canSubmitToAnotherValidator}
                      validationStatus={validationStatus}
                      pendingValidationComments={pendingValidationComments}
                    />
                  ) : (
                    <>{this.sectionInThisContentStudyMaterial()}</>
                  )}
                </div>
              </Grid>
              <Grid item className={classes.marginTop20} xs={8}>
                {/* <BreadcrumbCreateContent
                    type={type}
                    subType={subType}
                    requestId={requestId}
                    actionType={actionType}
                    history={history}
                    content={content}
                  /> */}
                {this.getCreateComponent(actionType)}
              </Grid>
              <Grid
                item
                xs={2}
                className={this.getSidePanelCssClasses(content)}
              >
                  <MyPATCollapseSection padTop activeSectionKey={isTeacher && (validationFeedbacks || []).length ? 'feedbackSec' : ''}>
                  {content._id && (
                    <MyPATCollapseSectionItem
                      sectionKey="previewPageInfo"
                      sectionName="Page Info"
                      icon="/assets/svg/new-info.svg"
                    >
                      <PreviewPageInfo
                        content={{ ...this.state.content }}
                        validations={
                          type === "question" && subType != "5"
                            ? this.props.validations
                            : null
                        }
                        deleteContent={this.deleteContent}
                        contentHistory={contentHistory}
                        requestId={requestId}
                        contentRequestIds={contentRequestIds}
                      />
                    </MyPATCollapseSectionItem>
                  )}

                  {!!validationFeedbacks.length &&
                    <MyPATCollapseSectionItem
                      sectionKey='feedbackSec'
                      sectionName={`Feedback`}
                      icon='/assets/svg/feedback-icon.svg'
                      count={validationFeedbacks.length}
                    >
                      <FeedbackSidebar
                        createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                        validationFeedbacks={validationFeedbacks}
                        allowFeedbacks={false}
                        selectedQuestionRef={this.state.selectedQuestionRef}
                        validationEditHistory={validationEditHistory}
                        fromContentCreate={true}
                      />
                    </MyPATCollapseSectionItem>
                  }

                  {validationEditHistory.length &&
                    <MyPATCollapseSectionItem
                      sectionKey='historySec'
                      sectionName={`${titleCase(type)} History`}
                      icon='/assets/svg/history-icon.svg'
                    >
                      <ContentValidationEditHistory
                        editHistory={validationEditHistory}
                        createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                        selectedQuestionRef={this.state.selectedQuestionRef}
                      />
                    </MyPATCollapseSectionItem>
                  }

                  {(type === "question" || type === "studymaterial") && (
                    <MyPATCollapseSectionItem
                      sectionKey="easyMaths"
                      sectionName="Easy Maths"
                      icon="/assets/svg/easy-math.svg"
                    >
                      <EasyMaths />
                    </MyPATCollapseSectionItem>
                  )}

                  {content._id && !this.props.fromFeedback && (type !== "question" || !isTeacher || validationStatus === FEEDBACK_VALIDATOR_ACTIONS.REJECTED) && (
                   !isStudent && <MyPATCollapseSectionItem
                      sectionKey="sharedWithContent"
                      sectionName={`Shared With (${
                        _.get(content, "aclMetaData.allowedTo", []).length
                      })`}
                      icon="/assets/svg/shared.svg"
                    >
                      <SharedContentWith content={content} />
                    </MyPATCollapseSectionItem>
                  )}

                  {content._id && (type !== "question" || !isTeacher || validationStatus === FEEDBACK_VALIDATOR_ACTIONS.REJECTED) && (
                      !isStudent &&
                    <MyPATCollapseSectionItem
                      sectionKey="otherRelatedContent"
                      sectionName="Other Related Content"
                      icon="/assets/svg/related.svg"
                    >
                      <OtherRelatedContent content={content} />
                    </MyPATCollapseSectionItem>
                  )}
                  {content._id && this.props.fromFeedback && (type !== "question" || !isTeacher || validationStatus === FEEDBACK_VALIDATOR_ACTIONS.REJECTED) && (
                    <MyPATCollapseSectionItem
                      sectionKey="feedback"
                      count={feedBackData &&
                        feedBackData.totalCount}
                      sectionName={`Feedback ${feedBackData &&
                        feedBackData.totalCount}`}
                      icon="/assets/svg/feedback-icon.svg"
                    >
                      <FeedbackPreview
                        feedBackData={feedBackData}
                        handleFeedbackResolve={this.handleFeedbackClick}
                        loadMoreFeedback={this.loadMoreFeedback}
                      />
                    </MyPATCollapseSectionItem>
                  )}
                  {content._id && type!=='testpapers'&& (
                   !isStudent && <MyPATCollapseSectionItem
                      sectionKey="suggestions"
                      sectionName="Duplicate and Similar"
                      icon="/assets/svg/duplicateSimilarIcon.svg"
                    >
                      <ContentSuggestions
                        contentType={type==='studymaterial'?subType:type}
                        contentId={content.content_Id}
                      />
                    </MyPATCollapseSectionItem>
                  )}

                </MyPATCollapseSection>
                {content._id && (
                  <ContentDeleteConfirm
                    isDeleteDialogOpen={isDeleteDialogOpen}
                    contentList={[content]}
                    onDeleteConfirmed={this.onDeleteConfirmed}
                  />
                )}
              </Grid>
            </Grid>
          </div>
        )}
        <Grid>
          {/* <MyPATToaster 
           icon={<CancelIcon />}
           heading="Error"
           toasterAlignment="TopRight"
           toasterType="error"
           subPara="Your license has been expired, please contact your supervisor for license renewal."
          /> */}

          {this.state.showToastMsg && <MyPATToaster 
           icon={<InfoIcon />}
           heading="Alert"
           toasterAlignment="TopRight"
           toasterType="warning"
           subPara="Few Duplicate & Similar content found, you can check them out in the widget."
           handleClose={()=>{
             this.setState({showToastMsg:false});
           }}
           autoClose={true}
          /> }


          {/* { <MyPATToaster 
           icon={<CheckCircleIcon />}
           heading="Success"
           toasterAlignment="TopRight"
           toasterType="success"
           subPara="Your license has been expired, please contact your supervisor for license renewal."
          />} */}
          </Grid>
      </ContentSaveContext.Provider>
    );
  }
}

const mapStateToProps = (state: any) => ({
  contentList: _.get(state, 'mylibraryData.content.list', []),
  contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
  validations: state.questionCreate.validations,
  tagsList: _.get(state, 'mylibraryData.contentTags.list', []),
  notesData: _.get(state, 'studyMaterialReducer'),
  pageTabState: state.wrapperTabsReducers.pageTabState,
  videoContentData: _.get(state, 'videoDetailsReducers'),
  audioContentData: _.get(state, 'audioDetailsReducer'),
  uploadedVideoUrl: _.get(state, 'videoCreateContent.videoURL', {}),
  accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
  accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
  accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
  feedBackData: state.contentRequestReducer.contentRequestReducer.feedBackData,
  refreshFeedback: state.contentRequestReducer.contentRequestReducer.refreshFeedback,
  commentList: _.get(state, 'mylibraryData.comment.list', []),
	commentCount: _.get(state, 'mylibraryData.comment.count', 0),
	lockData: _.get(state, 'mylibraryData.content.lockData', {}),
	requiresForceSaveForChallenge: _.get(state, 'mylibraryData.content.requiresForceSaveForChallenge'),
	// all question content state 
	title: state.questionCreate.title,
	optionsContent: state.questionCreate.optionsContent,
	matrixOptionContent: state.questionCreate.matrixOptionContent,
	correctAnswer: state.questionCreate.correctAnswer,
  customAnswer: state.questionCreate.customAnswer,
  syllabusExams: state.questionCreate.syllabusExams,
	solutionContent: state.questionCreate.solutionContent,
	stepWiseSolution: state.questionCreate.stepWiseSolution,
	questionHints: state.questionCreate.questionHints,
	subjects: state.questionCreate.subjects,
	secondarySubjects: state.questionCreate.secondarySubjects,
	difficultyLevel: state.questionCreate.difficultyLevel,
	difficultyType: state.questionCreate.difficultyType,
	relevantExams: state.questionCreate.relevantExams,
	tags: state.questionCreate.tags,
	defaultCorrectAnswer: state.questionCreate.defaultCorrectAnswer,
	alternateAnswer: state.questionCreate.alternateAnswer,
	isValidAttempts: state.questionCreate.isValidAttempts,
	questionBenchmarks: state.questionCreate.questionBenchmarks.benchmarks,
	idealTime: state.questionCreate.idealTime,
	allQuestionBenchmarks: state.questionCreate.questionBenchmarks,
  suggestions:state.mylibraryData.content.contentSuggestions,
  currentlyFocusedSection: state.commonData.focusedSection.currentlyFocusedSection,
  questionPreviousExams:_.get(state,"questionCreate.questionPreviousExams",{}),
  questionSpecialPurposes: state.questionCreate.specialPurposes,
  remedialQuestionIds:  state.questionCreate.remedialQuestionIds
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  eventFired: eventFired,
  setTitle: questionActions.setTitle,
  setOptionsContent: questionActions.setOptionsContent,
  setMatrixOptionsContent: questionActions.setMatrixOptionsContent,
  setCorrectAnswer: questionActions.setCorrectAnswer,
  setCustomAnswer: questionActions.setCustomAnswer,
  setSolutionContent: questionActions.setSolutionContent,
  setSubjects: questionActions.setSubjects,
  setSecondarySubjects: questionActions.setSecondarySubjects,
  setTags: questionActions.setTags,
  setEditRights: questionActions.setEditRights,
  setQuestionHints: questionActions.setQuestionHints,
  setDifficultyLevel: questionActions.setDifficultyLevel,
  setDifficultyType: questionActions.setDifficultyType,
  setRelevantExams: questionActions.setRelevantExams,
  setSyllabusExams: questionActions.setSyllabusExams,
  setValidations: questionActions.setValidations,
  setDraftId: questionActions.setDraftId,
  setDefaultCorrectAnswer: questionActions.setDefaultCorrectAnswer,
  setIsValidAttempts: questionActions.setIsValidAttempts,
  setNotesData: studyActions.handleNotesData,
  resetNotesData:studyActions.resetNotesData,
  setIdealTime: questionActions.setIdealTime,
  setalternateAnswer: questionActions.setAlternateAnswer,
  tabClicked,
  showAlert: showAlert,
  showMsg: showAlert,
  setContentRequestState: contentRequestStateAction.setContentRequestStates,
  setVideoDetailsData: videoDetailsActions.addVideoDetails,
  setAudioDetailsData :audioDetailsActions.addAudioDetails,
  setRequiresForceSaveForChallenge: contentActions.setRequiresForceSaveForChallenge,
  setPublishedContent: questionActions.setPublishedContent,
  setStepWiseSolutions: questionActions.setStepWiseSolutions,
  setIsComingFrom: contentRequestAccordianActions.setIsComingFrom,
  setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
  setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
  setTestAccordian: contentRequestAccordianActions.setTestAccordian,
  getFeedback: getFeedback,
  // New Ones
  updateQuestionBenchmarks: contentActions.updateQuestionBenchmarks,
  setContentSuggestions: contentActions.setContentSuggestions,
  setPreviousExams:questionActions.setPreviousExam,
  handleNotesData: studyActions.handleNotesData,
  showLoader: () => dispatch({ type: "SHOW_LOADER" }),
  hideLoader: () => dispatch({ type: "HIDE_LOADER" }),
  setSelectedGoals: (data: any) => dispatch(questionActions.setSelectedGoals(data)),
  setSpecialPurposes: questionActions.setSpecialPurposes,
  setAllRelevantExams: questionActions.setAllRelevantExams,
  setAllPreviousExams: questionActions.setAllPreviousExams,
  setFtreRelevantExam: questionActions.setFtreRelevantExam,
}, dispatch);

export{ContentSaveContext};
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContentCreate));